import CyclingCache from "../cache/CyclingCache";
import InfoText from "./InfoText";

export default class InfoTextCache extends CyclingCache {
    constructor() {
        super();
    }

    /**
     * @override
     * @returns {number}
     */
    getGrowAmount() {
        return 10;
    }

    /**
     * @override
     * @returns {number}
     */
    getInitialSize() {
        return 10;
    }

    /**
     * @returns {InfoText}
     */
    createInstance() {
        return new InfoText();
    }
}